import styled from 'styled-components';

import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const DropLine = () => {
  return (
    <LineContainer>
      <BlueLine />
    </LineContainer>
  );
};
const LineContainer = styled.div({
  margin: 'auto',
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: pxToRem(20),
  alignItems: 'center',
});

export const BlueLine = styled.div({
  position: 'absolute',
  left: 0,
  top: `calc(50% - ${pxToRem(2)})`,
  minHeight: pxToRem(4),
  width: '100%',
  borderRadius: pxToRem(8),
  background: theme.color.blue100,
});
